var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29235 21.3327C5.4251 21.3327 3.7626 20.1374 3.15885 18.3559L3.1186 18.2212C2.97685 17.7487 2.9156 17.3532 2.9156 16.9559V9.0022L0.0876021 18.4522C-0.276398 19.8417 0.553102 21.2837 1.94435 21.6669L19.9851 26.4987C20.2091 26.5582 20.4349 26.5844 20.6554 26.5844C21.8174 26.5844 22.8796 25.8144 23.1754 24.6769L24.2254 21.3344H7.29235V21.3327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 9.08274C11.7865 9.08274 12.833 8.03624 12.833 6.74999C12.833 5.46374 11.7865 4.41724 10.5002 4.41724C9.21398 4.41724 8.16748 5.46374 8.16748 6.74999C8.16748 8.03624 9.21398 9.08274 10.5002 9.08274Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0828 0.917236H7.58278C5.97453 0.917236 4.66553 2.22624 4.66553 3.83449V16.6672C4.66553 18.2755 5.97453 19.5845 7.58278 19.5845H25.0828C26.691 19.5845 28 18.2755 28 16.6672V3.83449C28 2.22449 26.691 0.917236 25.0828 0.917236ZM7.58278 3.24999H25.0828C25.4048 3.24999 25.6655 3.51074 25.6655 3.83274V12.1155L21.98 7.81574C21.5898 7.35724 21.0228 7.11224 20.4155 7.09824C19.8118 7.10174 19.243 7.36949 18.8563 7.83499L14.525 13.036L13.1145 11.6255C12.3165 10.8275 11.018 10.8275 10.22 11.6255L7.00003 14.8455V3.83274C7.00003 3.51074 7.26078 3.24999 7.58278 3.24999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleyWhite);
export default __webpack_public_path__ + "static/media/galleyWhite.527cf56f933ebc0c8da24123f55a9d54.svg";
export { ForwardRef as ReactComponent };